<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Optik" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop :detailTop="detailTop" />
          <div class="row mb-2">
            <div class="col-md-7 pr-1">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/optik/save" method="POST" enctype="multipart/form-data"-->
          <div>
            <div class="d-flex flex-between my-3">
              <h5 class="mb-2">Data Resep Optik</h5>
            </div>
            <table class="responsive mb-3">
              <thead>
                <th>EYE</th>
                <th>SPH</th>
                <th>CYL</th>
                <th>AXIS</th>
                <th>ADD</th>
                <th>PD</th>
                <th>MPD</th>
                <th>PV</th>
                <th>PRISMA</th>
                <th>KETERANGAN</th>
              </thead>
              <tbody>
                <tr>
                  <td>O.D.</td>
                  <td>
                    <input type="number" class="form-control" value="-5.25" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-1.00" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="65" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-" />
                  </td>
                  <td>
                    <input class="form-control desc" value="Diisi keterangan" />
                  </td>
                </tr>
                <tr>
                  <td>O.S.</td>
                  <td>
                    <input type="number" class="form-control" value="-5.25" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-1.00" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="65" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-" />
                  </td>
                  <td>
                    <input type="number" class="form-control" value="-" />
                  </td>
                  <td>
                    <input class="form-control desc" value="Diisi keterangan" />
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="form-group">
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group">
                    <input
                      type="number"
                      :class="
                        'form-control form-control-lg pl-5 with-icon-left without-label ' +
                          (isError ? 'error' : '')
                      "
                      placeholder="Cari kode atau nama lensa/frame di sini"
                      v-model="no_rm"
                      v-on:keyup.enter="() => searchAction()"
                    />
                    <i
                      class="material-symbols-outlined"
                      style="margin-top: -0.25rem"
                      >search</i
                    >
                    <div class="input-group-append">
                      <button
                        class="btn btn-secondary btn-with-icon-left"
                        @click="() => searchAction()"
                      >
                        <i class="material-symbols-outlined">add</i>
                        TAMBAHKAN
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <table class="responsive">
              <thead>
                <th>KODE</th>
                <th>NAMA BARANG</th>
                <th>JENIS Barang</th>
                <th>STOK</th>
                <th>HARGA/SATUAN</th>
                <th>JUMLAH</th>
                <th>EMBALASE</th>
                <th>TUSLAH</th>
                <th>SUB TOTAL</th>
              </thead>
              <tbody>
                <tr>
                  <td>L05316</td>
                  <td>Lensa abcdefgh</td>
                  <td>LENSA</td>
                  <td>5</td>
                  <td>Rp 10.000/buah</td>
                  <td>
                    <InputNumber :input="{ value: 3, class: 'inline' }" />
                  </td>
                  <td>
                    <InputMoney
                      :input="{ value: 1000, class: 'group-inline' }"
                    />
                  </td>
                  <td>
                    <InputMoney
                      :input="{ value: 4000, class: 'group-inline' }"
                    />
                  </td>
                  <td>
                    Rp 35.000
                    <button class="btn btn-icon btn-danger btn-sm ml-2">
                      <i class="material-symbols-outlined">delete</i>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>F05316</td>
                  <td>Frame abcdefg</td>
                  <td>FRAME</td>
                  <td>5</td>
                  <td>Rp 10.000/buah</td>
                  <td>
                    <InputNumber :input="{ value: 3, class: 'inline' }" />
                  </td>
                  <td>
                    <InputMoney
                      :input="{ value: 1000, class: 'group-inline' }"
                    />
                  </td>
                  <td>
                    <InputMoney
                      :input="{ value: 4000, class: 'group-inline' }"
                    />
                  </td>
                  <td>
                    Rp 35.000
                    <button class="btn btn-icon btn-danger btn-sm ml-2">
                      <i class="material-symbols-outlined">delete</i>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="8" style="text-align: right !important">
                    <h4 class="my-2">Total Biaya Optik</h4>
                  </td>
                  <td colspan="1">
                    <h4 class="my-2 pr-5">Rp 70.000</h4>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  simpan data Optik
                </button>
                <!-- <router-link
                  class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                  to="/optik"
                >Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => goBack('/optik')"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
// import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import InputMoney from "@/components/InputMoney.vue";
import InputNumber from "@/components/InputNumber.vue";
// formRowItem =  {
//     colnum: 1,
//     columns: [
//     {
//         label: '',
//         type: '',
//         placeholder: '',
//         name: '',
//         value: '',
//         mandatory: true,
//         multiple: false,
//         options: [
//         {
//             label: '',
//             value: ''
//         }
//         ],
//         additional: ''
//     }
//     ]
// },
let data = {
  title: "Tebus Resep Optik",
  backBtn: "/optik",
  actionBtn: [],
  breadcrumb: [
    { title: "Optik", link: "/optik" },
    { title: "Tebus Resep Optik", active: true },
  ],
};

let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" },
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)",
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)",
        },
      ],
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat",
        },
      ],
    },
  ],
};

let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "confirmation_number",
        colwidth: 6,
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "label_outline",
        colwidth: 6,
      },
    ],
  },
];
let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps",
  },
];

export default {
  name: "OptikForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    DetailTop,
    DetailLeft,
    DetailRight,
    InputNumber,
    InputMoney,
    // FormRow
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      detailTop: detailTop,
      detailLeftTop: detailLeftTop,
      detailRightTop: detailRightTop,
      no_rm: "",
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm() {
      //console.log("handled");
      window.location.href = "/optik";
    },
    searchAction() {
      //console.log("search");
    },
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
};
</script>
